export default "__VITE_ASSET__Cp2tS$oj__"